import { FormState as CreditRatingFormState } from "src/components/CreditRatingForm/CreditRatingForm";
import { SoftCreditPullRequestPayload } from "src/services/softCreditPull";
import { isNumber } from "src/utils/object";
import { Person } from "Types/api/Person";

export const getRequestPayloadForSoftCreditPull = (data: CreditRatingFormState): SoftCreditPullRequestPayload => ({
    city: data.city,
    first_name: data.firstName,
    last_name: data.lastName,
    monthly_income: data.income,
    state: data.state,
    street1: data.address,
    year_of_birth: data.year,
    zip: data.postal,
});

export const getRequestPayloadForPatchPerson = (data: CreditRatingFormState): Person => ({
    city: data.city,
    email: data.email,
    first_name: data.firstName,
    last_name: data.lastName,
    state: data.state,
    street1: data.address,
    zip: data.postal,
});

export const areScoresValid = (lowScore: number | undefined, highScore: number | undefined): boolean => {
    return isNumber(lowScore) && isNumber(highScore);
};
